import NavigableValidation from "./navigableValidation";
import DetailView from "../detailView/detailView";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import ListView from "~/models/listViews/listView";
import {IErrorNavOpts} from "~/models/validationError";
import EmbeddedCollectionValidator from "~/models/navigableValidators/embeddedCollectionValidator";

export default class DetailViewBuilderValidation extends NavigableValidation<DetailView> {
  validators = [
    new EmbeddedCollectionValidator({
      validatorKey: 'content_elements',
      section: ValidationModalSection.Layout
    }, this.model),
  ];

  errorNavOpts(validator: NavigableValidator<ListView>, validatorKey: string, value?, ...rest): IErrorNavOpts {
    const opts = super.errorNavOpts(validator, validatorKey, value, ...rest);
    if (validator.section === ValidationModalSection.Layout) {
      opts.containerElementSelector = ".scroll-area.dual-nav-builder"
    }
    return opts
  }
}